exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".KyEuzfplGYRaozHD-aLAm{padding:30px 50px;display:flex;flex-flow:column;align-items:center}.KyEuzfplGYRaozHD-aLAm div{padding-top:20px;font-size:15px;font-weight:22px}._2-DOH4XaUzkjEtkzOVGzE6{display:flex;justify-content:flex-end}._2-DOH4XaUzkjEtkzOVGzE6 a._1xYFn0l2OUzxgjfQpq5Xc-{max-width:144px;padding:12px 20px}._2-DOH4XaUzkjEtkzOVGzE6 a._1JuWS32cJlbA-QhHCb6PVo{max-width:120px;padding:12px 15px}._2-DOH4XaUzkjEtkzOVGzE6 a._2gCiQOwIdc5Ryn9dGiTkpS{padding:12px 30px 12px 15px;max-width:155px}\n", ""]);

// Exports
exports.locals = {
	"body": "KyEuzfplGYRaozHD-aLAm",
	"footer": "_2-DOH4XaUzkjEtkzOVGzE6",
	"specificity": "_1xYFn0l2OUzxgjfQpq5Xc-",
	"leftLink": "_1JuWS32cJlbA-QhHCb6PVo",
	"middleLink": "_2gCiQOwIdc5Ryn9dGiTkpS"
};